function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useEffect, useState } from 'react';
import { useApi } from '@deephaven/jsapi-bootstrap';
import Log from '@deephaven/log';
import useTableListener from "./useTableListener.js";
import ColumnNameError from "./ColumnNameError.js";
import TableDisconnectError from "./TableDisconnectError.js";
var log = Log.module('useTable');
var useTable = (table, firstRow, lastRow, columnNames) => {
  var dh = useApi();
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    columns = _useState2[0],
    setColumns = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    columnError = _useState6[0],
    setColumnError = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    tableError = _useState8[0],
    setTableError = _useState8[1];
  useEffect(() => {
    if (columnNames === undefined) {
      setColumns(table === null || table === void 0 ? void 0 : table.columns);
      setColumnError(null);
      return;
    }
    try {
      setColumns(table === null || table === void 0 ? void 0 : table.findColumns(columnNames));
      setColumnError(null);
    } catch (e) {
      log.error("Column not found", e, columnNames);
      setColumnError(new ColumnNameError('Invalid columnNames argument'));
    }
  }, [table, columnNames]);
  useEffect(() => {
    if (!columns || !table) {
      log.debug2('Table or column not initialized, skip viewport update.');
      return;
    }
    log.debug2('Setting viewport', firstRow, lastRow);
    table.setViewport(firstRow, lastRow, columns);
  }, [columns, table, firstRow, lastRow]);
  var handleUpdate = useCallback(_ref => {
    var detail = _ref.detail;
    if (!columns) {
      log.error('Columns not initialized.');
      return;
    }
    var viewportData = columns.map(column => detail.rows.map(r => r.get(column)));
    setData(viewportData);
  }, [columns]);
  var handleDisconnect = useCallback(() => {
    setTableError(new TableDisconnectError('Table disconnected'));
  }, []);
  var handleReconnect = useCallback(() => {
    setTableError(null);
  }, []);
  useTableListener(table, dh.Table.EVENT_UPDATED, handleUpdate);
  useTableListener(table, dh.Table.EVENT_DISCONNECT, handleDisconnect);
  useTableListener(table, dh.Table.EVENT_RECONNECT, handleReconnect);
  return {
    columns,
    data,
    error: tableError !== null && tableError !== void 0 ? tableError : columnError
  };
};
export default useTable;
//# sourceMappingURL=useTable.js.map